import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function LinkExpertModal({ organization, onClose }) {
  const queryClient = useQueryClient();
  const [expertId, setExpertId] = useState('');
  const [ssCode, setSsCode] = useState('');

  const { data: experts = [] } = useQuery({
    queryKey: ['experts', 'link-picker'],
    queryFn: async () => (await api.get('/experts')).data?.data ?? [],
  });

  const { data: meta } = useQuery({
    queryKey: ['iqp-register', 'meta'],
    queryFn: async () => (await api.get('/iqp-register/meta')).data,
  });

  const mutation = useMutation({
    mutationFn: (body) => api.post('/service-network/affiliations', body),
    onSuccess: () => {
      toast.success('Engineer linked to company');
      queryClient.invalidateQueries({ queryKey: ['service-network'] });
      onClose();
    },
    onError: (e) => toast.error(e.response?.data?.error || 'Link failed'),
  });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
      <div className="bg-card rounded-lg shadow-xl max-w-md w-full p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">Link engineer</h3>
        <p className="text-sm text-gray-500 mb-4">{organization?.name}</p>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Engineer / installer</label>
            <select
              value={expertId}
              onChange={(e) => setExpertId(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            >
              <option value="">Select…</option>
              {experts.map((ex) => (
                <option key={ex.id} value={ex.id}>
                  {ex.name} ({ex.type})
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">SS scope (optional)</label>
            <select
              value={ssCode}
              onChange={(e) => setSsCode(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            >
              <option value="">All SS for this company</option>
              {(meta?.ssList ?? []).map((code) => (
                <option key={code} value={code}>
                  {code}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900">
            Cancel
          </button>
          <button
            type="button"
            disabled={!expertId || mutation.isPending}
            onClick={() =>
              mutation.mutate({
                organization_id: organization.id,
                entity_type: 'EXPERT',
                entity_id: Number(expertId),
                ss_code: ssCode || null,
                relation: 'AFFILIATED',
                source: 'MANUAL',
              })
            }
            className="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50"
          >
            Link
          </button>
        </div>
      </div>
    </div>
  );
}
